import { supabase } from "@/lib/supabase";
import type { RealtimeChannel } from "@supabase/supabase-js";

export const partnershipTypingKey = (
  partnerId: string,
  studentId: string,
  normalizedSubject: string
) => {
  const subject = normalizedSubject
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
  return `partnership_typing:${partnerId}:${studentId}:${subject}`;
};

export type PartnershipTypingSession = {
  channel: RealtimeChannel;
  sendTyping: (isTyping: boolean) => Promise<void>;
  unsubscribe: () => Promise<void>;
};

export const joinPartnershipTyping = (
  partnerId: string,
  studentId: string,
  normalizedSubject: string,
  currentUserId: string,
  onPeerTyping: (isTyping: boolean) => void
): PartnershipTypingSession => {
  const key = partnershipTypingKey(partnerId, studentId, normalizedSubject);
  const channel = supabase.channel(key);

  channel.on("broadcast", { event: "typing" }, ({ payload }) => {
    const userId = payload?.userId as string | undefined;
    if (!userId || userId === currentUserId) return;
    onPeerTyping(payload?.isTyping === true);
  });

  void channel.subscribe();

  return {
    channel,
    sendTyping: async (isTyping: boolean) => {
      await channel.send({
        type: "broadcast",
        event: "typing",
        payload: {
          userId: currentUserId,
          isTyping,
        },
      });
    },
    unsubscribe: async () => {
      await supabase.removeChannel(channel);
    },
  };
};
